<script lang="ts">
  import { Tag } from "@gl/design-system"
  import { StatusEnum, type Status } from "../../services/models"

  export let status: Status = {} as Status;

  const resolveTagStatus = (s: Status) => {
    switch(s.status) {
      case StatusEnum.CREATED:
        return ""
      case StatusEnum.CANCELED:
      case StatusEnum.FAILURE:
        return "error"
      case StatusEnum.FAILED_GENERATION:
        return "warning"
      case StatusEnum.ENQUEUED:
        case StatusEnum.GENERATING:
        return "secondary"
      case StatusEnum.FINISHED_GENERATION:
      case StatusEnum.UPLOADING:
      case StatusEnum.FINISHED:
        return "success"
      
    }
  } 
</script>

<Tag status={resolveTagStatus(status)}>
  {status.status}
</Tag>